import { ConditionGroupViewModel } from './conditionGroupViewModel';
import { ConditionViewModel } from './conditionViewModel';

export class ConditionGroup {
  public static find(
    conditionGroup: ConditionGroupViewModel,
    predicate: (search: ConditionViewModel) => boolean,
  ): ConditionViewModel | undefined {
    for (const c of conditionGroup.conditions) {
      if (this.isCondition(c)) {
        if (predicate(c)) {
          return c;
        }
      } else {
        return this.find(c, predicate);
      }
    }

    return undefined;
  }

  public static findAll(
    conditionGroup: ConditionGroupViewModel,
    predicate: (search: ConditionViewModel) => boolean,
  ): ConditionViewModel[] {
    const matchingConditions: ConditionViewModel[] = [];
    ConditionGroup.forEachCondition(conditionGroup, (condition: ConditionViewModel) => {
      if (predicate(condition)) {
        matchingConditions.push(condition);
      }
    });
    return matchingConditions;
  }

  public static forEachCondition(
    conditionGroup: ConditionGroupViewModel | undefined,
    callback: (condition: ConditionViewModel) => void,
  ) {
    if (conditionGroup) {
      conditionGroup.conditions.forEach((c) => {
        if (this.isCondition(c)) {
          callback(c);
        } else {
          ConditionGroup.forEachCondition(c, callback);
        }
      });
    }
  }

  public static isGroupInvalid(conditionGroup: ConditionGroupViewModel): boolean {
    return conditionGroup.conditions.some((c) => {
      if (this.isCondition(c)) {
        return c.invalid;
      } else {
        return this.isGroupInvalid(c);
      }
    });
  }

  public static isCondition(item: ConditionViewModel | ConditionGroupViewModel): item is ConditionViewModel {
    if ((item as ConditionViewModel).attribute) {
      return true;
    }
    return false;
  }
}
